import React, { useRef } from "react";
import ProjectPreview from "./ProjectPreview";
import {
  Opacity as OpacityAnimation,
  SideMove,
  useOnMouseHover,
} from "@liro_u/react-animation-components";

const AnimatedProjectPreview = ({ project, index, style = {}, ...content }) => {
  const ref = useRef(null);
  const isHover = useOnMouseHover(ref);

  return (
    <div ref={ref}>
      <SideMove
        key={index}
        translateXStart={(index % 2 === 0 ? "" : "-") + "100%"}
        {...content}
        mainBoxStyle={{
          zIndex: isHover ? 100 : 0,
        }}
      >
        <OpacityAnimation>
          <ProjectPreview
            name={project.name}
            _id={project._id}
            image={project.image}
            project={project}
            style={style}
          />
        </OpacityAnimation>
      </SideMove>
    </div>
  );
};

export default AnimatedProjectPreview;
